module.exports = __webpack_public_path__ + "img/issueInformation.ae338e52.png";